import axios from 'axios'
import url from '../urls'

export default {
  add (_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(url.VocClozeAssignmentResultUrl, data)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },

  getById (_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${url.VocClozeAssignmentResultUrl}/${id}`)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },

  getByAssignment (_context, { studentId, assignmentId }) {
    return new Promise((resolve, reject) => {
      axios
        .get(url.VocClozeAssignmentResultUrl, {
          params: { studentId, assignmentId }
        })
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  }
}
